import Image from 'next/image';
import Link from 'next/link';
import React, { useCallback } from 'react';

import { ButtonCTA } from 'components/elements/ButtonCTA/ButtonCTA';
import useMediaQuery from 'hooks/useMediaQuery';
import { useTranslation } from 'hooks/useTypedTranslation';
import { AUTH_WEB_URL } from 'modules/auth/utils/constants';
import { useIsDesktop } from 'modules/listening/hooks/useIsDesktop';
import { playbackStoreActions } from 'modules/listening/stores/playback/playbackStore';
import { logSegmentEvent } from 'utils/analytics';
import { extendedTheme } from 'utils/extended-theme';

export const GuestAccountBanner: React.FC = () => {
  const { t } = useTranslation('common');
  const isDesktop = useIsDesktop();
  const { matches: isWideScreen } = useMediaQuery('(min-width: 768px)');
  const { matches: isFullyShowBanner } = useMediaQuery('(min-width: 800px)');
  const isWideLayout = isDesktop && isWideScreen;

  const onCreateAccount = useCallback(() => {
    playbackStoreActions.pause();
    logSegmentEvent('web_app_shared_document_signup_pressed', {});
    window.location.href = `${AUTH_WEB_URL}?returnTo=${encodeURIComponent(window.location.href)}&mode=sign-up`;
  }, []);

  return (
    <div className="px-4">
      <div
        style={{
          position: 'relative',
          width: '100%',
          marginTop: '1.5rem',
          marginBottom: '20rem',
          fontFamily: "'ABCDiatype'",
          maxWidth: '766px',
          minWidth: isFullyShowBanner ? '766px' : '740px'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: isWideLayout ? 'row' : 'column',
            alignItems: 'center',
            backgroundColor: 'var(--color-bg-prim-w-90)',
            padding: isWideLayout ? '1.25rem' : '1rem',
            borderRadius: '1rem',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            border: '1px solid transparent',
            position: 'relative'
          }}
        >
          <div style={{ width: '100px', height: '100px', flexShrink: 0, marginBottom: isWideLayout ? 0 : '1rem', marginRight: isWideLayout ? '0.75rem' : 0 }}>
            <Image
              src="https://cdn.speechify.com/web/assets/guest-listening-screen-banner.png"
              alt="Speechify Voices"
              width={200}
              height={200}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </div>
          <div style={{ flexGrow: 1, textAlign: isWideLayout ? 'left' : 'center', marginBottom: isWideLayout ? 0 : '1rem', fontFamily: "'ABCDiatype'" }}>
            <span className="text-subheading-3 text-icn-txt-prim">{t('Get more with Speechify account')}</span>
            <p className="text-body-6 text-icn-txt-prim">
              {t('Enjoy 50+ natural sounding voices, enhance your speed up to 4.5x, summarize any file with AI, skip headers, footers, brackets and more.')}
            </p>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              width: isWideLayout ? '16rem' : '100%', //
              maxWidth: isWideLayout ? '147px' : undefined,
              flexShrink: 0,
              position: 'relative',
              zIndex: 10
            }}
          >
            <ButtonCTA onClick={onCreateAccount} className="w-full mb-1 text-heading-6 px-6">
              {t('Create Account')}
            </ButtonCTA>
            <Link
              href={AUTH_WEB_URL}
              style={{
                display: 'block',
                width: '100%',
                padding: '0.5rem 1.5rem',
                cursor: 'pointer',
                border: 'none',
                backgroundColor: 'transparent',
                fontFamily: "'ABCDiatype'",
                fontSize: extendedTheme.fontSize['subheading-6'][0],
                ...extendedTheme.fontSize['subheading-6'][1],
                textDecoration: 'none',
                textAlign: 'center'
              }}
              className="text-icn-txt-prim hover:opacity-75 active:opacity-50"
            >
              {t('Sign in')}
            </Link>
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '0.75rem',
            zIndex: 0,
            padding: '2px',
            mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            maskComposite: 'exclude'
          }}
          className="bg-aiGradient"
        />
      </div>
    </div>
  );
};
